export default __webpack_public_path__ + "static/media/serviceBlack.700bff77.svg";